import React, { useEffect } from "react";
import { ClassData } from "../model/ClassData";
import { SchoolData } from "../model/SchoolData";
import "../pages/dashboard/Dashboard.css";

interface EditClassModalProps {
  isOpen: boolean;
  classData: ClassData | null;
  // Admins must pick a school when creating; omit for school members.
  schools?: SchoolData[];
  defaultSchoolId?: string;
  onClose: () => void;
  onSave: (data: { name: string; schoolId?: string }) => void;
}

const EditClassModal: React.FC<EditClassModalProps> = ({
  isOpen,
  classData,
  schools,
  defaultSchoolId,
  onClose,
  onSave,
}) => {
  const [name, setName] = React.useState(classData?.name || "");
  const [schoolId, setSchoolId] = React.useState(defaultSchoolId || "");

  useEffect(() => {
    setName(classData?.name || "");
    setSchoolId(defaultSchoolId || "");
  }, [classData, defaultSchoolId, isOpen]);

  if (!isOpen) return null;
  const isCreateMode = !classData;
  const needsSchool = isCreateMode && !!schools;
  const canSave = !!name.trim() && (!needsSchool || !!schoolId);

  const handleSave = () => {
    if (!canSave) return;
    onSave({
      name: name.trim(),
      schoolId: needsSchool ? schoolId : undefined,
    });
    setName("");
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">
            {isCreateMode ? "Tạo lớp mới" : "Sửa lớp"}
          </h2>
          <button onClick={onClose} className="modal-close-button">
            ×
          </button>
        </div>

        <div className="modal-section">
          {needsSchool && (
            <div className="modal-field" style={{ marginBottom: 12 }}>
              <label className="modal-label">Trường học</label>
              <select
                className="modal-value"
                value={schoolId}
                onChange={(e) => setSchoolId(e.target.value)}
              >
                <option value="">-- Chọn trường --</option>
                {schools!.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="modal-field">
            <label className="modal-label">Tên lớp</label>
            <input
              type="text"
              className="modal-value"
              placeholder="Ví dụ: 10A1"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
            />
          </div>
        </div>

        <div className="modal-actions">
          <button
            onClick={onClose}
            className="modal-button modal-button-secondary"
          >
            Huỷ
          </button>
          <button
            onClick={handleSave}
            className="modal-button modal-button-primary"
            disabled={!canSave}
          >
            {isCreateMode ? "Tạo" : "Lưu"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditClassModal;
